import axios from 'axios'

class AuthService {
  constructor() {
    this.baseUrl = '/api/v1/reset_password'
  }

  reset(data) {
    return axios.post(`${this.baseUrl}/confirm/`, data)
  }

  validate(code) {
    return axios.post('/api/v1/users/validate/', code)
  }

  codeRetrieval(data) {
    return axios.post('/api/v1/users/coderetrieval/', data)
  }

  getLogo(orgName) {
    return axios.get(`/api/v1/organization_detail_by_name/${orgName}`)
  }

  getWelcomeDetails(orgId) {
    return axios.get(`/api/v1/users/get_welcome_messages/${orgId}`)
  }

  fetchUserData() {
    return axios.get(`/api/v1/me/`)
  }

  getAllOrgDetails() {
    return axios.get(`/api/v1/organization_detail/`)
  }
}

export const authService = new AuthService()
